import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';
import { zThemeSettings } from 'utils/ui-helpers/stackingContexts';

const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: 'absolute',
    bottom: 12,
    right: 12,
    zIndex: zThemeSettings,
  },
  settingsButton: {
    '& *': {
      pointerEvents: 'none',
    },
  },
  menu: {
    display: 'flex',
    flexFlow: 'column',
    marginBottom: theme.spacings.s16,
    padding: `${theme.spacings.s8} ${theme.spacings.s0}`,
    minWidth: 146,
    backgroundColor: theme.colors.backgrounds.base,
    border: `2px solid ${theme.colors.backgrounds.tint3}`,
  },
}));

export default useStyles;
